<rpc-omnibox [placeholder]="'OMNI_SEARCH.TITLES.PLACEHOLDER'" [iconName]="iconName()" [color]="'accent'"
    [disabled]="disabled" [readonly]="readonly" [selectedValues]="selectedValues"
    [autocomleteOptions]="autocomleteOptions$ | async" (patternChanged)="onPatternChanged($event)"
    (valueAdded)="onValueAdded($event)" (valueRemoved)="onValueRemoved($event)">
</rpc-omnibox>